<template>
    <div
        class="flex-center icons-panel"
        :class="{ 'small': size === 'small' }"
    >
        <div
            class="facebook-btn flex flex-center"
            v-if="facebook"
            @click="shared({ social: 'facebook' })"
        >
            <a
                :href="`https://www.facebook.com/sharer/sharer.php?u=${facebook}`"
                target="_blank"
                rel="noopener"
            >
                <i class="fab fa-facebook-f" />
            </a>
        </div>

        <div
            class="whatsapp-btn flex flex-center"
            @click="shared({ social: 'whatsapp' })"
            v-if="inviteFriend && !$mq.isDesktop()"
        >
            <a :href="`whatsapp://send?text=${whatsapp}`">
                <i class="fab fa-whatsapp" />
            </a>
        </div>

        <div
            class="mail-btn flex flex-center"
            @click="shared({ social: 'mail' })"
        >
            <a :href="`mailto:?to=&subject=${mail.subject}&body=${mail.body}`">
                <i class="fa fa-envelope" />
            </a>
        </div>

        <div
            class="copy-btn flex flex-center"
            @click="copy()"
            v-if="copyString"
            ref="copyBtn"
        >
            <i class="fas fa-link" />

            <transition name="modal-on">
                <div
                    v-if="copyAlert"
                    class="copy-alert"
                    :style="[transform]"
                >
                    <div class="arrow-up" />
                    <div class="arrow-up-border" />

                    <div
                        class="alert-content"
                        v-html="`Copiato`"
                    />
                </div>
            </transition>
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        props: {
            facebook: {
                type: String,
                default: null
            },

            whatsapp: {
                type: String,
                default: 'Hai visto questa novità in cucina? Si chiama Quomi e ti consegna a casa un box con gli ingredienti dosati per preparare le ricette che scegli sul sito. https://goo.gl/hS5QBM'
            },

            mail: {
                type: Object,
                default () {
                    return {
                        subject: 'Prova Quomi.it!',
                        body: 'Hai visto questa novità in cucina? Si chiama Quomi e ti consegna a casa un box con gli ingredienti dosati per preparare le ricette che scegli sul sito. https://goo.gl/hS5QBM'
                    }
                }
            },

            copyString: {
                type: String,
                default: null
            },

            size: {
                type: String,
                default: `big`
            },

            inviteFriend: {
                type: Boolean,
            }
        },

        data () {
            return {
                copyAlert: false,
                width: 32
            }
        },

        computed: {
            transform () {
                return {
                    transform: `translateX(50%) translateX(-${this.width / 2}px)`
                }
            }
        },

        methods: {
            copy () {
                var str = this.copyString
                const el = document.createElement('textarea');  // Create a <textarea> element
                el.value = str;                                 // Set its value to the string that you want copied
                el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
                el.style.position = 'absolute';                 
                el.style.left = '-9999px';                      // Move outside the screen to make it invisible
                document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
                const selected =            
                document.getSelection().rangeCount > 0        // Check if there is any content selected previously
                  ? document.getSelection().getRangeAt(0)     // Store selection if found
                  : false;                                    // Mark as false to know no selection existed before
                el.select();  
                el.setSelectionRange(0, 9999)                                  // Select the <textarea> content
                document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
                document.body.removeChild(el);                  // Remove the <textarea> element
                if (selected) {                                 // If a selection existed before copying
                    document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
                    document.getSelection().addRange(selected);   // Restore the original selection
                }

                this.showAlert()
                this.width = this.$refs.copyBtn.offsetWidth

                this.shared({ social: 'copy' })
            },

            showAlert () {
                this.copyAlert = true
                setTimeout(() => {
                    this.copyAlert = false
                }, 2000)
            },

            shared (params) {
                this.$emit('shared', params)
            }
        }

    }
</script>

<style scoped>
.icons-panel {
    margin: 0 -4px;
}

[class*="-btn"] {
    margin: 0 4px;
    border-radius: 6px;
    height: 50px;
    width: 50px;
    color: white;
    text-align: center;
    cursor: pointer;
    position: relative;
}

[class*="-btn"] a {
    color: white;
    font-size: 24px;
    display: block;
    width: 100%;
    height: 100%;
    line-height: 2.2;
}

.small [class*="-btn"]{
    height: 32px;
    width: 32px;
}

.small [class*="-btn"] a {
   font-size: 15px;
}

.whatsapp-btn {
    background: #25D366;
}

.facebook-btn {
    background: #3b5998;
}

.mail-btn {
    background: #cc043b;
}

.copy-btn {
    background: #ffb400;
}

.copy-alert {
    overflow: initial;
    /*opacity: 1;*/
    position: absolute;
    bottom: -40px;
    max-width: 100px;
    right: 0px;
    height: auto;
    z-index: 999;
}

.alert-content {
    background: white;
    color: grey;
    padding: 5px 10px;
    border-radius: 4px;
    border: 1px solid #ededed;
}

.arrow-up,
.arrow-up-border {
    width: 0; 
    height: 0; 
    position: absolute;
    top: -5px;
    right: 50%;
    transform: translateX(50%);
}
.arrow-up {
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid white;
    z-index: 1;
}

.arrow-up-border {
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid black;
    z-index: -1;
}
</style>